import { getBackendUrl } from "@Utils";
import { getUrlForImage } from "../cubeComponent/constants/globalFunctions";
import { CONSTANTS } from "../cubeComponent/constants/globalVariable";
import axiosWrapper from "../services/axiosWrapper";
import { setUserDetails, updateUserDetails as updateUserDetailsAction } from "../reducers/userDetailsSlice";
import { setCheckIfAuthenticated } from "../reducers/authentication";

export const saveUserDetails = setUserDetails;
export const updateUserDetails = updateUserDetailsAction;

export function getUserDetails() {
  return (dispatch: any) => {
    axiosWrapper.get(`${getBackendUrl()}/accounts/getUserDetails`).then((response) => {
      if (response && response.data.status) {
        const res = response.data.data[0];
        dispatch(
          saveUserDetails({
            ...res,
            lastName: res.lastName ? res.lastName : "",
            profilePicUrl: res.profilePic ? getUrlForImage(res) : "",
            company: {
              ...res.company,
              logoUrl: res.company?.logo ? getUrlForImage(res.company, CONSTANTS.ORGANIZATION) : "",
            },
            // portal: {
            //   ...res.portal,
            //   logoUrl: res?.portal?.logo ? getUrlForImage(res.portal, CONSTANTS.PORTAL) : '',
            // },
            signatureUrl: res.signature
              ? `${getBackendUrl()}/fileSystemServer/getSignDocs/${res.signature}?${Date.now()}`
              : "",
            status: true,
          }),
        );
      } else {
        dispatch(
          saveUserDetails({
            status: false,
          }),
        );
      }
    });
  };
}

export async function initiateSignupEmailVerification(email: string) {
  return await axiosWrapper.post(`${getBackendUrl()}/accounts/initiateSignupEmailVerification`, {
    email,
  });
}

export function getCheckIfAuthenticated() {
  return (dispatch: any) => {
    axiosWrapper
      .get(`${getBackendUrl()}/accounts/checkIfAuthenticated`, {
        withCredentials: true,
      })
      .then((response) => {
        dispatch(setCheckIfAuthenticated({ data: response.data }));
        return response.data;
      });
  };
}
